import * as actionTypes from '../constants/userActionTypes';

const defaultState = {
    partners: [],
    partnersOptions: [],
    loading: false,
    errors: {}
}

export const partnerReducers = (state = defaultState, action = {}) => {
    switch (action.type) {
        // GET ACTIVITY SCHEDULE
        case actionTypes.GET_PARTNER_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.GET_PARTNER_SUCCESS:
            return {
                ...state,
                loading: false,
                partners: action.payload.data,
            }
        case actionTypes.GET_PARTNER_FAIL:
            return {
                ...state,
                error: action.payload
            }
        case actionTypes.CLEAR_GET_PARTNERS:
            return {
                ...state,
                error: null,
                message: null
            }
        // LOADE PARTNERS OPTION 
         case actionTypes.LOAD_PARTNER_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.LOAD_PARTNER_SUCCESS:
            return {
                ...state,
                loading: false,
                partnersOptions: action.payload.data.partners,
            }
        case actionTypes.LOAD_PARTNER_FAIL:
            return {
                ...state,
                error: action.payload
            }
        // CREATE PARTNER
        case actionTypes.CREATE_PARTNER_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.CREATE_PARTNER_SUCCESS:
            return {
                loading: false,
                message: action.payload?.message,
                errors: {},
                partners: [...state.partners, action.payload?.data],
            }
        case actionTypes.CREATE_PARTNER_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case actionTypes.CLEAR_CREATE_PARTNER:
            return {
                ...state,
                error: null,
                message: null
            }
        // // DELETE ACTION
        case actionTypes.DELETE_PARTNER_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.DELETE_PARTNER_SUCCESS:
            return {
                ...state,
                loading: false,
                partners: state.partners.filter(item => item.partner_id !== action.payload.partner_id),
                message: action.payload.message

            }
        case actionTypes.DELETE_PARTNER_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload

            }
        case actionTypes.DELETE_PARTNER_RESET:
            return {
                ...state,
                error: null,
                message: null
            }


        // CHECK INVITATION EMAIL
        case actionTypes.CHECK_INVITATION_EMAIL_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.CHECK_INVITATION_EMAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                message: action.payload?.message,
                errors: {},
                isRegisterd: action.payload?.data?.is_registered,
                isRegisterdUser: action.payload?.data?.is_already_used,
                projectTitle: action.payload?.data?.title,
                // isRegisterd: true,
            }
        case actionTypes.CHECK_INVITATION_EMAIL_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case actionTypes.CLEAR_CHECK_INVITATION_EMAIL:
            return {
                ...state,
                error: null,
                message: null
            }
        default:
            return state;
    }
}